<template>
  <div class="modal_wrap common_storeChatMessageModal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_close pnt" ref="modal_close" @click="$emit('close')">
          <img src="@/assets/front/images/i_x_w.svg" alt="" />
        </div>
        <div class="modal_head">
          <h1 class="h1">자주 쓰는 문구</h1>
        </div>
        <div class="modal_con" v-if="this.shop.storeMessages.msg_a">
          <div
            class="request_table radio"
            v-for="(item, index) in this.shop.storeMessages.msg_a"
            v-bind:key="index"
          >
            <div class="modal_message pnt" @click="storeMsgSel(item.message)">
              {{ item.message }}
            </div>
            <div class="modal_del_img pnt" @click="storeMsgDel(item.id)">
              <img src="@/assets/front/images/i_x_c_2.svg" alt="" />
            </div>
          </div>
          <div ref="dummy"></div>
        </div>
        <div class="modal_con" v-else>
          <div class="modal_con_txt">
            <p>자주 쓰는 문구를 등록해 보세요.</p>
            <p>최대 20개까지 등록이 가능합니다.</p>
          </div>
        </div>
        <div class="modal_btn">
          <div
            class="modal_btn_txt"
            v-if="this.shop.storeMessages.msg_a.length >= 20"
          >
            최대 20개까지 등록이 가능합니다.
          </div>
          <div class="chat_write" v-else ref="msg_write_wrap">
            <label class="input chat_textbox">
              <textarea
                maxlength="300"
                ref="msg_textbox"
                placeholder="문구를 입력해 주세요 (최대 300자)"
                @keyup="textareaMsg"
                v-on:input="handleChangeOftenMessage"
                v-bind:value="oftenMessage"
              />
              <button
                type="submit"
                :disabled="!oftenMessage"
                @click="storeMsgSave"
              >
                저장
              </button>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkMobileOperatingSystem } from '@common/lib/common/utils';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';

export default {
  name: 'StoreMessageModal',
  props: {
    // shop: Object,
  },
  components: {},
  data() {
    return {
      isOpen: false,
      oftenMessage: '',
      messageType: 'A',
    };
  },
  // async beforeRouteEnter(to, from, next) {
  //   return await next(async vm => {
  //     await vm.getStoreChatMessageList(this.shop.id);
  //   });
  // },
  // // 디바이스 뒤로가기 눌렀을때 마다 호출
  // async beforeRouteUpdate(to, from, next) {
  //   console.log(3);
  //   await this.getStoreChatMessageList(this.shop.id);
  //   next();
  //   // return next(async vm => {
  //   //   await vm.chatFetch();
  //   // });
  // },
  created() {},
  computed: {
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
  },
  methods: {
    ...shopMapActions([
      shopTypes.FETCH_SHOP,
      shopTypes.SHOP_MESSAGE_DELETE,
      shopTypes.SHOP_MESSAGE_INSERT,
    ]),
    async storeMsgSel(msg) {
      await this.$emit('storeMsg', msg);
      await this.$emit('close');
      await this.$emit('textareaMessageSel');
    },
    async getStoreChatMessageList(shop_id) {
      await this[shopTypes.FETCH_SHOP]({
        id: shop_id,
      });
    },
    async storeMsgDel(id) {
      try {
        var params = {
          id: id,
        };

        await this[shopTypes.SHOP_MESSAGE_DELETE](params);
        await this.getStoreChatMessageList(this.shop.id);
      } catch (e) {
        console.log(e);
      }
    },
    async storeMsgSave() {
      console.log(this.shop.id);
      try {
        var params = {
          storeId: this.shop.id,
          message: this.oftenMessage,
          messageType: this.messageType,
        };

        await this[shopTypes.SHOP_MESSAGE_INSERT](params);
        await this.getStoreChatMessageList(this.shop.id);

        this.$refs.dummy.scrollIntoView({ behavior: 'smooth' });

        this.oftenMessage = '';

        this.$refs.msg_textbox.style.height = '4rem';
        // this.$refs.msg_write_wrap.style.height = '5.4rem';
      } catch (e) {
        console.log(e);
      }
    },
    // 채팅 입력창 줄바꿈 처리
    textareaMsg(e) {
      this.$refs.textbox.style.height = 'auto';
      this.$refs.textbox.style.height = this.$refs.textbox.scrollHeight + 'px';
      // console.log(e.path);
      // const valueLength = e.target.value.length;
      // console.log(valueLength);
      // if (e.keyCode === 13 || e.keyCode === 8) {
      //   // console.log('enter');
      //   // console.log(e.target.value.split('\n'));
      //   const valueArr = e.target.value.split('\n');
      //   const valueArrCnt = valueArr.length;
      //   if (valueArrCnt >= 2 || valueLength > 18) {
      //     this.$refs.msg_textbox.style.height = '8rem';
      //     this.$refs.msg_write_wrap.style.height = 'auto';
      //   } else {
      //     this.$refs.msg_textbox.style.height = '4rem';
      //     this.$refs.msg_write_wrap.style.height = '5.4rem';
      //   }
      // } else {
      //   // console.log(e.target.value.length);
      //   if (valueLength > 18) {
      //     this.$refs.msg_textbox.style.height = '8rem';
      //     this.$refs.msg_write_wrap.style.height = 'auto';
      //   }
      // }
      const textbox_val = e.target.value.trim();
    },
    handleChangeOftenMessage(e) {
      this.oftenMessage = e.target.value;
    },
  },
};
</script>
